var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sign-setting" }, [
    _c(
      "div",
      { staticClass: "com-Breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: ">" } },
          [
            _c(
              "el-breadcrumb-item",
              [
                _c(
                  "router-link",
                  { staticClass: "item", attrs: { to: "/viewIndex" } },
                  [_vm._v("首页")]
                )
              ],
              1
            ),
            _c("el-breadcrumb-item", [
              _vm._v(_vm._s(_vm.computedCurrentMenuName))
            ])
          ],
          1
        ),
        _c(
          "router-link",
          { staticClass: "r-btn", attrs: { to: "/viewIndex" } },
          [_vm._v("返回上一步")]
        )
      ],
      1
    ),
    _c("div", { staticClass: "main-wrap" }, [
      _c(
        "div",
        { staticClass: "left-wrap" },
        [
          _c("apply-menu-tree", {
            style: { height: "100%" },
            attrs: {
              currentMenuName: _vm.currentMenuName,
              menus: _vm.switchMenus
            },
            on: {
              "update:currentMenuName": function($event) {
                _vm.currentMenuName = $event
              },
              "update:current-menu-name": function($event) {
                _vm.currentMenuName = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right-wrap" },
        [
          _vm.currentMenuName !== "账户管理" &&
          _vm.currentMenuName !== "常用签署方"
            ? _c("route-name", {
                style: {
                  fontSize: "16px",
                  lineHeight: "36px",
                  backgroundColor: "#fff",
                  fontWeight: "600",
                  borderBottom: "solid 1px #E5E5E5",
                  paddingTop: "15px"
                },
                attrs: { propsRouteName: _vm.computedCurrentMenuName }
              })
            : _vm._e(),
          _c("nuxt-child")
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43a6f40e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43a6f40e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/signSettings.vue
// module id = paUy
// module chunks = 94